<template>
	<v-container fluid class="crm-index d-flex flex-column"
		:style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<div class="d-flex align-center justify-end mb-2 flex-shrink-0">
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						fab
						dark
						x-small
						color="green"
						class="mx-2"
						v-if="lastWorkingContract"
						@click.stop="() => { selectRow(item); toContractDetail(lastWorkingContract); }"
						v-bind="attrs"
						v-on="on"
					>
						<v-icon small dark>mdi-briefcase</v-icon>
					</v-btn>
				</template>
				<span>Continuar Trabajando en Último Contrato</span>
			</v-tooltip>
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="$store.state.contracts.loadingCompanyContractsList"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.contracts.companyContractsListCount"
				:loading-info="$store.state.contracts.loadingCompanyContractsList"
				:showOrderBy="true"
				items-type="contracts"
			/>
		</div>
		<div class="table-container flex-grow-1 pb-2">
			<v-data-table
				:headers="headers"
				:items="$store.state.contracts.companyContractsList"
				:server-items-length="$store.state.contracts.companyContractsListCount"
				item-key="id"
				class="budget-table"
				:loading="$store.state.contracts.loadingCompanyContractsList"
				:options.sync="options"
				loading-text="Cargando datos..."
				hide-default-footer
				@click:row="selectRow"
				:item-class="selectedRowClass"
				:footer-props="{
					itemsPerPageText: 'Filas por página',
					'items-per-page-options': itemsPerPageOptions
				}"
			>
				<template v-slot:item.serial="{ item }">
					<div class="d-flex align-center fill-height">
						<v-tooltip bottom v-if="lastWorkingContract && lastWorkingContract.id == item.id">
							<template v-slot:activator="{ on, attrs }">
								<div 
									v-bind="attrs"
									v-on="on"
									class="last-worked-ribbon d-flex align-center justify-center">
									<v-icon x-small color="white" class="ribbon-icon">mdi-briefcase-outline</v-icon>
								</div>
							</template>
							<span>Lo trabajaste hace poco</span>
						</v-tooltip>
						<div class="py-1 px-2">
							<div style="width:100px;"><b>{{ item.serial?.serial }} - LP{{ item.morphable?.project_line_info?.project_line?.number }} - {{ item.contract_info?.prefix?.prefix }} {{ item.contract_info?.contract_prefix_index }}</b></div>
							<div class="mr-2 d-flex align-center">
								<v-icon class="mr-1" x-small>mdi-calendar</v-icon>
								<p class="mb-0" style="font-size: 10px;">{{ item.created_at | toDate }}</p>
							</div>
							<v-chip
								color="green"
								label
								outlined
								x-small
								v-if="item.id == $store.state.contracts.companyContractsLastId"
							>
								<b>Último Creado</b>
							</v-chip>
							<!-- <v-chip
								color="green"
								label
								x-small
								dark
								v-if="lastWorkingContract && lastWorkingContract.id == item.id"
								class="px-1"
							>
								<b>Lo trabajaste hace poco</b>
							</v-chip> -->
						</div>
					</div>
				</template>
				<template v-slot:item.client="{ item }">
					<div class="d-flex align-center">
						<div class="d-flex flex-column flex-grow-1">
							<b>{{ getUserName(item.morphable) }}</b>
							<div v-if="item.morphable">{{ item.morphable.client ? item.morphable.client.email:'No identificado'}}</div>
						</div>
						<div class="d-flex align-self-start align-start justify-end">
							<v-tooltip bottom v-if="item.morphable?.client?.company_profile && item.morphable?.client?.accreditation?.status">
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="#FF1209"
										v-bind="attrs"
										v-on="on">mdi-domain</v-icon>
								</template>
								<span>Cliente Empresa</span>
							</v-tooltip>
							<v-tooltip bottom v-else>
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="#959595"
										v-bind="attrs"
										v-on="on">mdi-account</v-icon>
								</template>
								<span>Cliente Persona Natural</span>
							</v-tooltip>
						</div>
					</div>
				</template>
				<template v-slot:item.details="{ item }">
					<div>
						<div class="d-flex">
							<div class="d-flex align-center flex-grow-1">
								<v-icon small class="mr-2">mdi-ruler-square</v-icon> <p class="mb-0 font-weight-bold">{{ item.morphable?.name }}</p>
							</div>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										color="warning"
										x-small
										v-bind="attrs"
										v-on="on"
										disabled
										@click.stop="() => { selectRow(item); gotToAssociation(item); }"
									>
										<v-icon dark small>mdi-eye-outline</v-icon>
									</v-btn>
								</template>
								<span>Ir al detalle</span>
							</v-tooltip>
						</div>
						<div class="d-flex align-center">
							<div class="d-flex align-center flex-grow-1" v-if="item.morphable">
								<div class="d-flex align-center flex-grow-1" v-if="item.morphable.responsible">
									<v-icon small class="mr-2" color="green">mdi-account-check-outline</v-icon>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<p
												class="mb-0 text-truncate font-weight-bold"
												v-bind="attrs"
												v-on="on"
											>
												{{ item.morphable.responsible.profile.name + ' ' + item.morphable.responsible.profile.lastname  + ' ' + item.morphable.responsible.profile.second_lastname }}
											</p>
										</template>
										<span>{{ item.morphable.responsible.profile.name + ' ' + item.morphable.responsible.profile.lastname  + ' ' + item.morphable.responsible.profile.second_lastname }}</span>
									</v-tooltip>
								</div>
								<div class="d-flex align-center flex-grow-1" v-else>
									<v-icon small class="mr-2" color="warning">mdi-account-cancel-outline</v-icon>
									<b>Sin Responsable</b>
								</div>
							</div>
							<v-menu offset-y z-index="9999" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
								<template v-slot:activator="{ on, attrs }">
									<v-tooltip bottom>
										<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
											<v-btn
												icon
												color="warning"
												x-small
												@click="selectRow(item)"
												:disabled="!$checkPermissions(['assign_responsible_user'])"
												v-bind="{ ...attrs, ...tooltipAttrs }"
												v-on="{ ...on, ...tooltipOn }"
											>
												<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
											</v-btn>
										</template>
										<span>Cambiar Responsable</span>
									</v-tooltip>
								</template>
								<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
									<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
										<p class="caption mb-0 font-weight-bold white--text">Cambiar Responsable</p>
									</v-list-item>
									<v-list-item-group color="#524D4D">
										<v-list-item
											v-for="(responsible, index) in companyUserList"
											:key="index"
											dense
											@click.stop="() => { selectRow(item); changeResponsible(item, responsible.id); }"
										>
											<v-list-item-title dense>
												<div class="d-flex align-center">
													<img :src="responsible.profile.avatar" class="user-avatar mr-2" v-if="responsible?.profile?.avatar"/>
													<v-icon v-else class="user-avatar icon mr-2" color="#524D4D">mdi-account</v-icon>
													<div>
														<p class="mb-0">{{ responsible.profile?.name }} {{ responsible.profile?.lastname }} {{ responsible.profile?.second_lastname }}</p>
														<p class="mb-0 caption">{{ responsible.email }}</p>
													</div>
												</div>
											</v-list-item-title>
										</v-list-item>
									</v-list-item-group>
								</v-list>
							</v-menu>
						</div>
					</div>
				</template>
				<template v-slot:item.address="{ item }">
					<div>
						<p class="mb-0 font-weight-bold">{{ item.morphable?.name || item.morphable?.info?.project_detail || 'Sin Nombre' }}</p>
						<p class="mb-0">{{ item.morphable?.info?.address?.address || 'Sin Dirección' }}</p>
						<p class="mb-0">{{ item.morphable?.info?.project_type?.name || 'Sin Tipo de Proyecto' }}</p>
					</div>
				</template>
				<template v-slot:item.status="{ item }">
					<div class="py-1">
						<div class="d-flex align-center flex-grow-1">
							<div class="d-flex align-center flex-grow-1">
								<v-chip
									:color="item.last_status?.status | contractStatusColor"
									label
									outlined
									x-small
									class="mb-1 px-1 wrap-chip d-flex align-center flex-grow-1 justify-center"
								>
									<div class="d-flex align-center flex-column text-center flex-grow-1">
										<b>{{ item.last_status?.status | contractStatus }}</b>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<div class="d-flex align-center"
													v-bind="attrs"
													v-on="on">
													<v-icon class="mr-1" x-small>mdi-calendar</v-icon>
													<p class="mb-0 caption font-weight-bold" style="font-size: 10px;">{{ item.last_status?.created_at | toDate }}</p>
												</div>
											</template>
											<span>Fecha de último cambio de estado</span>
										</v-tooltip>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-icon
													style="position: absolute;bottom: 2px;right: 2px;" size="9px"
													:color="getCurrentDiffColor(item.last_status?.created_at)"
													v-bind="attrs"
													v-on="on">mdi-circle</v-icon>
											</template>
											<span>Tiempo de espera: {{ getCurrentDiffText(item.last_status?.created_at) }}</span>
										</v-tooltip>
									</div>
								</v-chip>
							</div>

							<!-- <v-menu offset-y z-index="9999" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										dark
										small
										icon
										color="#524D4D"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
									</v-btn>
								</template>
								<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
									<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
										<p class="caption mb-0 font-weight-bold white--text">Cambiar Estado</p>
									</v-list-item>
									<v-list-item-group color="#524D4D">
										<v-list-item
											v-for="(status, index) in contractStatuses"
											:key="index"
											dense
											@click.stop="() => { selectRow(item); changeContractStatus(item.id, status.value); }"
										>
											<v-list-item-title dense>
												{{ status.title }}
											</v-list-item-title>
										</v-list-item>
									</v-list-item-group>
								</v-list>
							</v-menu> -->
						</div>
						<div class="d-flex align-center justify-end flex-grow-1">
							<!-- <v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-chip
										label
										outlined
										x-small
										:color="getCurrentDiffColor(item.last_status?.created_at)"
										class="px-1 mr-1 d-flex align-center flex-grow-1 justify-center"
										v-bind="attrs"
										v-on="on"
									>
										<b>{{ getCurrentDiffText(item.last_status?.created_at) }}</b>
									</v-chip>
								</template>
								<span>Último cambio de estado: {{ getCurrentDiffText(item.last_status?.created_at)}}</span>
							</v-tooltip> -->
							<v-chip
								label
								outlined
								x-small
								color="#959595"
								class="px-1 d-flex align-center flex-grow-1 justify-center"
							>
								<b>{{ getAddendumText(item.addendums) }}</b>
							</v-chip>
						</div>
					</div>
				</template>
				<template v-slot:item.actions="{ item }">
					<div class="d-flex align-center justify-center" style="width: 100px;">
						<v-tooltip bottom v-if="$store.state.user.userInfo">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									class="mx-1"
									icon
									dark
									x-small
									color="#959595"
									@click.stop="() => { selectRow(item); toContractDetail(item); }"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon small dark>mdi-briefcase</v-icon>
								</v-btn>
							</template>
							<span>Ver Detalle</span>
						</v-tooltip>
						<div style="position:relative;">
							<div style="
								width: 15px;
								height: 15px;
								background-color: grey;
								border-radius: 50%;
								position: absolute;
								top: -5px;
								right: 0px;
								color: white;
							">
							{{ item.addendums.length }}
							</div>
							<v-menu offset-y left>
								<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
									<v-tooltip bottom>
										<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
											<v-btn
												class="mx-2"
												icon
												dark
												x-small
												color="green"
												@click="selectRow(item)"
												v-bind="{ ...menuAttrs, ...tooltipAttrs }"
												v-on="{ ...menuOn, ...tooltipOn }"
											>
												<v-icon>mdi-briefcase-plus</v-icon>
											</v-btn>
										</template>
										<span>Anexos de Contrato</span>
									</v-tooltip>
								</template>
								<v-list dense class="py-0" style="min-width: 250px;">
									<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
										<div class="d-flex justify-space-between align-center w-100">
											<p class="caption mb-0 font-weight-bold white--text">Anexos de Contrato</p>
										</div>
									</v-list-item>
									<v-list-item-group color="#524D4D" v-if="item.addendums.length">
										<v-list-item
											v-for="(addendum, index) in item.addendums"
											:key="'ass-'+index"
											dense
											@click.stop="() => { goToAddendum(item, addendum) }"
											style="min-width: 200px"
										>
											<v-list-item-title dense>
												<div class="d-flex justify-space-between align-center item-background-hover">
													<div class="d-flex align-center justify-space-between caption" style="width: 100%">
														<div style="width: 90px">Ir a Anexo</div>
														<div class="text-end">
															<b class="text-end" style="flex: 1;">Nº {{addendum.addendum_index}}</b>
															<p class="caption">{{ addendum.created_at | toDate }}</p>
														</div>
													</div>
												</div>
											</v-list-item-title>
										</v-list-item>
									</v-list-item-group>
									<v-list-item v-else>
										<div class="d-flex justify-center align-center caption">
											<p class="mb-0">No hay anexos asociados a este contrato</p>
										</div>
									</v-list-item>
								</v-list>
							</v-menu>
						</div>
						<!-- Subcontracts Menu -->
						<div style="position:relative;">
							<div style="
								width: 15px;
								height: 15px;
								background-color: grey;
								border-radius: 50%;
								position: absolute;
								top: -5px;
								right: 0px;
								color: white;
							">
							{{ item.subcontracts.length }}
							</div>
							<v-menu offset-y left>
								<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
									<v-tooltip bottom>
										<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
											<v-btn
												class="mx-2"
												icon
												dark
												x-small
												color="green"
												@click="selectRow(item)"
												v-bind="{ ...menuAttrs, ...tooltipAttrs }"
												v-on="{ ...menuOn, ...tooltipOn }"
											>
												<v-icon>mdi-briefcase-outline</v-icon>
											</v-btn>
										</template>
										<span>Subcontratos</span>
									</v-tooltip>
								</template>
								<v-list dense class="py-0" style="min-width: 250px;">
									<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
										<div class="d-flex justify-space-between align-center w-100">
											<p class="caption mb-0 font-weight-bold white--text">Subcontratos</p>
										</div>
									</v-list-item>
									<v-list-item-group color="#524D4D" v-if="item.subcontracts.length">
										<v-list-item
											v-for="(subcontract, index) in item.subcontracts"
											:key="'ass-'+index"
											dense
											@click.stop="() => { goToSubcontract(item, subcontract) }"
											style="min-width: 200px"
										>
											<v-list-item-title dense>
												<div class="d-flex justify-space-between align-center item-background-hover">
													<div class="d-flex align-center justify-space-between caption" style="width: 100%">
														<div style="width: 90px">Ir a Subcontrato</div>
														<div class="text-end">
															<b class="text-end" style="flex: 1;">Nº {{subcontract.subcontract_index}}</b>
															<p class="caption">{{ subcontract.created_at | toDate }}</p>
														</div>
													</div>
												</div>
											</v-list-item-title>
										</v-list-item>
									</v-list-item-group>
									<v-list-item v-else>
										<div class="d-flex justify-center align-center caption">
											<p class="mb-0">No hay subcontratos asociados a este contrato</p>
										</div>
									</v-list-item>
								</v-list>
							</v-menu>
						</div>
						<div>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										class="mx-1"
										icon
										dark
										x-small
										color="#959595"
										@click.stop="() => { selectRow(item); $router.push({ name: 'ProjectCostBreakdown', params: { id: item.morphable_id } }); }"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon>mdi-currency-usd</v-icon>
									</v-btn>
								</template>
								<span>Ver Tabla de Costo del Proyecto</span>
							</v-tooltip>
						</div>
					</div>
				</template>
			</v-data-table>
		</div>
		<!-- <div class="d-flex align-center justify-end mt-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.contracts.companyContractsListCount"
				:loading-info="$store.state.contracts.loadingCompanyContractsList"
				:showOrderBy="true"
				items-type="contracts"
			/>
		</div> -->
  </v-container>
</template>

<script>
import moment from 'moment'
import _debounce from 'lodash/debounce'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {addNewStatus} from '@/helpers/api/contracts'

import {setResponsible as setResponsiblePreProject} from '@/helpers/api/preprojects'
import {setResponsible as setResponsibleProject} from '@/helpers/api/projects'
import {assignScheduleToUser} from '@/helpers/api/crm'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'

export default {
	name: 'ContractIndex',
	components: {
		DataTablePagination,
	},
  data() {
    return {
      search: '',
			selectedRowItem: null,
			searchInput: null,
			lastWorkingContract: null,
			itemsPerPageOptions: [10, 25, 50, 100, 200],
      options: {
        page: 1,
        itemsPerPage: 50,
				order_by: localStorage.getItem('contracts_order_by') ? parseInt(localStorage.getItem('contracts_order_by')) : 1,
      },
			contracts: [],
			loading: true,
			contractStatuses: [
				{value: 1, title: 'Creado'},
				{value: 2, title: 'Esperando Pago Contrato'},
				{value: 3, title: 'Contrato Pagado'},
				{value: 4, title: 'Esperando Visto Bueno Empresa / Profesional'},
				{value: 5, title: 'Visto Bueno Empresa / Profesional'},
				{value: 6, title: 'Enviado a Cliente'},
				{value: 7, title: 'Observado por Cliente'},
				{value: 8, title: 'Aceptado'},
				{value: 9, title: 'Rechazado'},
				{value: 10, title: 'Firmado Cliente'},
				{value: 11, title: 'Firmado Ambas Partes'},
			]
    };
  },
  computed: {
		companyUserList(){
			return this.$store.state.users.usersList
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		headers(){
			let headers = [
				{ text: 'Nº', value: 'serial', class: 'with-divider', cellClass: 'with-divider first-column-custom', sortable: false },
				{ text: 'Cliente', value: 'client', class: 'with-divider', cellClass: 'with-divider', width: '15%' },
        { text: 'Seguimiento y Responsable', value: 'details', class: 'with-divider', cellClass: 'with-divider', width: '20%' },
        { text: 'Proyecto', value: 'address', class: 'with-divider', cellClass: 'with-divider', width: '25%' },
        { text: 'Estado', value: 'status', class: 'with-divider', cellClass: 'with-divider', width: '15%' },
        { text: 'Acciones', value: 'actions', align: 'center', class: 'with-divider', cellClass: 'with-divider', sortable: false },
			]
			return headers.filter((header) => {
				return this.$store.state.contracts.listingColumns[header.value]
			})
		},
  },
	watch: {
    options: {
      handler() {
				this.reloadInfo()
      },
      deep: true,
    },
		selectedCompany(newValue){
			if(newValue){
				this.reloadInfo()
				this.$store.dispatch('users/getUserFromCompany')
			}
		}
	},
	mounted(){
		if(this.selectedCompany){
			this.reloadInfo()
		}
		const selectedRow = JSON.parse(localStorage.getItem('selected_contract_row'));
		if (selectedRow) {
			this.selectedRowItem = selectedRow
		}
		if(this.companyUserList.length == 0){
			this.$store.dispatch('users/getUserFromCompany')
		}
		this.setLastWorkingContract()
		eventBus.$on('changeGeneralOrderList', this.onChangeGeneralOrderList)
    eventBus.$on('reloadInformation', this.reloadInfo)
	},
	beforeDestroy(){
		eventBus.$off('reloadInformation', this.reloadInfo)
		eventBus.$off('changeGeneralOrderList', this.onChangeGeneralOrderList)
	},
  methods: {
		onChangeGeneralOrderList(value){
			this.options.order_by = value
			this.debounceReloadInfo()
		},
		debounceReloadInfo: _debounce(function() { this.reloadInfo() }, 300),
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_contract_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		getCurrentDiffText(created_at){
			const date1 = moment()
			const date2 = moment(created_at)
			const diffInDays = date1.diff(date2, 'days')
			if(diffInDays == 1){
				return `${diffInDays} día`
			}
			return `${diffInDays} días`
		},
		getCurrentDiffColor(created_at){
			const date1 = moment()
			const date2 = moment(created_at)
			const diffInDays = date1.diff(date2, 'days')
			if(diffInDays > 5){
				return '#FF120B'
			}
			else if(diffInDays > 2){
				return 'orange'
			}
			return 'green'
		},
		getAddendumText(addendums){
			if(addendums.length == 1){
				return `${addendums.length} anexo`
			}
			else if(addendums.length > 1){
				return `${addendums.length} anexos`
			}
			return 'Sin Anexos'
		},
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.reloadInfo()
		},
		async changeResponsible(item, responsible_id){
			const item_type = this.getType(item.morphable_type)
			if(item_type == 'crm'){
				await assignScheduleToUser({schedule_id: this.conversation.schedule.user_schedule.id, new_user_id: responsible_id})
			}
			else if(item_type == 'preproject'){
				await setResponsiblePreProject({preproject_id: item.morphable_id, responsible_id})
			}
			else if(item_type == 'project'){
				await setResponsibleProject({project_id: item.morphable_id, responsible_id, from_state: 'contract', contract_id: item.id})
			}
			this.reloadInfo()
		},
		async changeContractStatus(contract_id, status){
			const resp = await addNewStatus({contract_id, status})
			if(resp.code == 200){
				this.reloadInfo()
			}
		},
		reloadInfo(){
			let data = {
				...this.options,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
			}
			if(this.searchInput){
				data = {...data, ...{search: this.searchInput}}
			}
			this.$store.dispatch('contracts/getContracts', data)
		},
		setLastWorkingContract(){
			const contract = localStorage.getItem('last_working_contract')
			if(contract){
				const contract_data = JSON.parse(contract)
				this.lastWorkingContract = contract_data
			}
		},
		getUserName(item){
			let name = ''
			if(item && item.client && item.client.profile){
				name = item.client.profile.name + ' ' + item.client.profile.lastname + ' ' + item.client.profile.second_lastname
			}
			else{
				name = 'No identificado'
			}
			return name
		},
		getCompanyProjects(){
			this.$store.dispatch('projects/getProjects')
		},
		goToAddendum(item, addendum){
			this.selectRow(item);
			// this.$store.commit('contracts/setContractAddendumComponentModalId', null);
			// setTimeout(() => {
			// 	this.$store.commit('contracts/setContractAddendumComponentModalId', addendum.id);
			// }, 200);

			const screenWidth = window.screen.width;
			const screenHeight = window.screen.height;
			const finalWidth = Math.min(1000, screenWidth);

			window.open(
				`/built-in-content?type=addendum&id=${addendum.id}`,
				'',
				`width=${finalWidth},height=${screenHeight},left=${finalWidth},top=0,toolbar=no,menubar=no,location=no,status=no`
			);
		},
		goToSubcontract(item, subcontract){
			this.selectRow(item);
			// this.$store.commit('contracts/setSubcontractComponentModalId', null);
			// setTimeout(() => {
			// 	this.$store.commit('contracts/setSubcontractComponentModalId', subcontract.id);
			// }, 200);

			const screenWidth = window.screen.width;
			const screenHeight = window.screen.height;
			const finalWidth = Math.min(1000, screenWidth);

			window.open(
				`/built-in-content?type=subcontract&id=${subcontract.id}`,
				'',
				`width=${finalWidth},height=${screenHeight},left=${finalWidth},top=0,toolbar=no,menubar=no,location=no,status=no`
			);
		},
		toContractDetail(contract){
			localStorage.setItem('last_working_contract', JSON.stringify(contract))
			this.$router.push({ name: 'ContractDetail', query: { id: contract.id } })
		},
		getTypeIcon(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'mdi-contacts-outline'
				case "App\\Models\\PreProject":
					return 'mdi-information-variant-circle-outline'
				case "App\\Models\\Project":
					return 'mdi-ruler-square'
				default:
					break;
			}
			return 'Otro'
		},
		getTypeName(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'CRM'
				case "App\\Models\\PreProject":
					return 'PreProyecto'
				case "App\\Models\\Project":
					return 'Proyecto'
				default:
					break;
			}
			return 'Otro'
		},
		getType(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'crm'
				case "App\\Models\\PreProject":
					return 'preproject'
				case "App\\Models\\Project":
					return 'project'
				default:
					break;
			}
			return 'Otro'
		},
  },
};
</script>

<style>
.contract-index .message-container{
	margin-bottom: 0;
	font-size: 12px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.contract-index .message-container p{
	margin-bottom: 0;
	font-size: 12px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.contract-table table tr td{
	font-size: 11px!important;
}
.contract-table.resizable .v-data-table__wrapper th,
.contract-table.resizable .v-data-table__wrapper td {
	border-right: 1px solid #cacaca;
}
.first-column-custom{
	position: relative;
	padding: 0!important;
}
.last-worked-ribbon{
	background-color: #4CAF50;
	width: 20px;
	height: 100%;
  /* border-top: 30px solid #4CAF50;
  border-right: 30px solid transparent; */
}
.last-worked-ribbon .ribbon-icon{
}
</style>